import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ModalGeneric } from '../../../ui/generics';
import { IFlourPackingListItem } from '../../flour/core/interfaces';
import { IRestockingListItem } from '../../flour/core/interfaces/IRestockingListItem';

@Component({
    selector: 'app-delivery-note-error-modal',
    templateUrl: './delivery-note-error-modal.component.html',
    styleUrl: './delivery-note-error-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DeliveryNoteErrorModalComponent extends ModalGeneric {

  public deliveryResponse: IFlourPackingListItem | IRestockingListItem;

  public constructor (
    protected readonly cdr: ChangeDetectorRef
  ) {
    super(cdr);
  }

  public showModal(object: IFlourPackingListItem | IRestockingListItem): void {
    super.showModal(object);
    this.deliveryResponse = object;
    this.cdr.detectChanges();
  }
}
